import React from 'react';

import ChecklistLeadForm from 'components/ChecklistLeadForm';
import CtaWithHint from 'components/CtaWithHint';
import LegalPageLayout from 'components/LegalPageLayout';
import LocalizedLink from 'components/LocalizedLink';
import TrustProof from 'components/TrustProof';
import { useI18n } from 'i18n/I18nContext';

const OPEN_ITEMS = ['o1', 'o2', 'o3', 'o4', 'o5', 'o6'] as const;
const CLOSE_ITEMS = ['c1', 'c2', 'c3', 'c4', 'c5', 'c6'] as const;

const ChecklistPage = () => {
  const { t } = useI18n();

  return (
    <LegalPageLayout
      title={t('checklist.title')}
      lede={t('checklist.intro')}
      variant="marketing"
      wide
    >
      <div className="gb-checklist-grid">
        <section className="gb-checklist-panel" aria-labelledby="checklist-open-heading">
          <h2 id="checklist-open-heading" className="gb-checklist-panel__title">
            {t('checklist.openTitle')}
          </h2>
          <ol className="gb-checklist">
            {OPEN_ITEMS.map((key) => (
              <li key={key}>{t(`checklist.open.${key}`)}</li>
            ))}
          </ol>
        </section>

        <section className="gb-checklist-panel" aria-labelledby="checklist-close-heading">
          <h2 id="checklist-close-heading" className="gb-checklist-panel__title">
            {t('checklist.closeTitle')}
          </h2>
          <ol className="gb-checklist">
            {CLOSE_ITEMS.map((key) => (
              <li key={key}>{t(`checklist.close.${key}`)}</li>
            ))}
          </ol>
        </section>
      </div>

      <p className="mb-50 gb-prose-muted">{t('checklist.adaptNote')}</p>

      <section className="mb-50" aria-labelledby="checklist-lead-heading">
        <h2 id="checklist-lead-heading" className="text-lg font-bold mb-20">
          {t('checklist.formTitle')}
        </h2>
        <ChecklistLeadForm />
      </section>

      <div className="gb-resource-cta">
        <h2 className="text-lg font-bold mb-20">{t('checklist.nextTitle')}</h2>
        <p className="mb-25 gb-prose-muted">{t('checklist.nextBody')}</p>
        <CtaWithHint
          href="/onboard"
          buttonLabel={t('checklist.cta')}
          hint={t('checklist.ctaHint')}
        />
        <TrustProof className="mt-25" />
        <p className="mt-35 mb-0">
          <LocalizedLink className="text-green font-bold no-underline" to="/compare">
            {t('checklist.compareLink')}
          </LocalizedLink>
        </p>
      </div>
    </LegalPageLayout>
  );
};

export default ChecklistPage;



// WEBPACK FOOTER //
// ./src/pages/ChecklistPage.tsx